import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type StatusType = boolean;
export type StatusState = { status: StatusType };

const initialState: StatusState = { status: true };

export const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<StatusState>) => {
      state.status = action.payload.status;
    },
  },
});

export const { setStatus } = statusSlice.actions;

export default statusSlice.reducer;
